class NewsletterForm extends HTMLElement {
  constructor() {
    super();
    
    this.form = this.querySelector('form');
    this.emailInput = this.querySelector('input[type="email"]');
    this.submitButton = this.querySelector('button[type="submit"]');
    
    if (this.form) {
      // 创建一个隐藏的 iframe 用于表单提交
      this.createIframe();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
  }

  createIframe() {
    // 创建隐藏的 iframe
    const iframe = document.createElement('iframe');
    iframe.name = 'newsletter-iframe-' + Date.now();
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    
    // 设置表单的 target 为这个 iframe
    this.form.setAttribute('target', iframe.name);
    this.iframe = iframe;
    
    // 监听 iframe 加载完成
    iframe.addEventListener('load', () => {
      if (this.isSubmitting) {
        this.onFormSubmitted();
      }
    });
  }

  onSubmitHandler(event) {
    // 不阻止默认行为，让表单正常提交到 iframe
    
    if (this.submitButton.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      return;
    }

    // 禁用提交按钮，防止重复提交
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.submitButton.classList.add('loading');
    this.isSubmitting = true;
    
    // 表单会正常提交到 iframe，不会刷新页面
  }

  onFormSubmitted() {
    this.isSubmitting = false;
    
    try {
      // 尝试读取 iframe 内容来检查是否有错误
      const iframeDoc = this.iframe.contentDocument || this.iframe.contentWindow.document;
      const iframeBody = iframeDoc.body;
      
      // 检查是否有错误
      const hasError = iframeBody && (
        iframeBody.innerHTML.includes('error') || 
        iframeBody.innerHTML.includes('Error') ||
        iframeBody.querySelector('.errors')
      );
      
      if (hasError) {
        this.showErrorMessage();
      } else {
        // 显示成功消息
        this.showSuccessMessage();
        // 清空输入框
        this.emailInput.value = '';
      }
    } catch (e) {
      // 如果无法访问 iframe 内容（跨域），假设成功
      console.log('Cannot access iframe content, assuming success');
      this.showSuccessMessage();
      this.emailInput.value = '';
    }
    
    // 重新启用提交按钮
    this.submitButton.removeAttribute('aria-disabled');
    this.submitButton.classList.remove('loading');
  }

  showSuccessMessage() {
    // 清除之前的错误消息
    const existingError = this.querySelector('.banner-newsletter__error');
    if (existingError) {
      existingError.remove();
    }

    // 显示成功消息
    let successDiv = this.querySelector('.banner-newsletter__success');
    if (!successDiv) {
      successDiv = document.createElement('div');
      successDiv.className = 'banner-newsletter__success';
      const confirmMessage = this.dataset.confirmMessage || 'Thank you for subscribing';
      successDiv.textContent = confirmMessage;
      
      // 在 banner-newsletter__bottom 容器的最前面插入成功消息
      const bottomContainer = this.closest('.banner-newsletter__bottom');
      if (bottomContainer) {
        bottomContainer.insertBefore(successDiv, bottomContainer.firstChild);
      } else {
        // 降级方案：在表单前插入
        this.form.insertBefore(successDiv, this.form.firstChild);
      }
    }
    
    successDiv.style.display = 'block';
    
    // 3秒后隐藏成功消息
    setTimeout(() => {
      successDiv.style.display = 'none';
    }, 3000);
  }

  showErrorMessage() {
    // 清除之前的成功消息
    const existingSuccess = this.querySelector('.banner-newsletter__success');
    if (existingSuccess) {
      existingSuccess.style.display = 'none';
    }

    // 显示错误消息
    let errorDiv = this.querySelector('.banner-newsletter__error');
    if (!errorDiv) {
      errorDiv = document.createElement('div');
      errorDiv.className = 'banner-newsletter__error';
      errorDiv.textContent = 'Something went wrong. Please try again.';
      
      // 在 banner-newsletter__bottom 容器的最前面插入错误消息
      const bottomContainer = this.closest('.banner-newsletter__bottom');
      if (bottomContainer) {
        bottomContainer.insertBefore(errorDiv, bottomContainer.firstChild);
      } else {
        // 降级方案：在表单前插入
        this.form.insertBefore(errorDiv, this.form.firstChild);
      }
    }
    
    errorDiv.style.display = 'block';
  }
}

customElements.define('newsletter-form', NewsletterForm);
